import loadingDialog from '../components/global/lottie/loadingDialog'

const dialogLoading = {
  install: function (Vue) {
    const LoadingConstructor = Vue.extend(loadingDialog)
    const instance = new LoadingConstructor()
    instance.$mount(document.createElement('div'))
    document.body.append(instance.$el)
    Vue.prototype.$dialogLoading = {
      open: (title) => {
        instance.title = title
        instance.centerDialogVisible = true
      },
      close: () => {
        instance.centerDialogVisible = false
      }
    }
    window.$dialogLoading = Vue.prototype.$dialogLoading
  }
}

export default dialogLoading



// WEBPACK FOOTER //
// ./src/util/dialogLoading.js